

import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const OrganizerPage = () => {
  const [title, setTitle] = useState("");
  const [venue, setVenue] = useState("");
  const [price, setPrice] = useState("");
  const [totalTickets, setTotalTickets] = useState(""); // أو أي قيمة افتراضية

  const [description, setDescription] = useState("");
  const [datetime, setDatetime] = useState(""); // ✅ رجعناه

  const [mediaFile, setMediaFile] = useState(null);

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const organizerId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");

    if (!organizerId || !token) {
      setErrorMsg("برجاء تسجيل الدخول أولاً.");
      return;
    }

    const formData = new FormData();
    formData.append("Title", title);
    formData.append("Venue", venue);
    formData.append("TicketPrice", price);
    formData.append("TotalTickets", totalTickets);

    formData.append("Description", description);

    formData.append("EventDatetime", datetime); // ✅ رجعنا السطر ده

    formData.append("OrganizerId", organizerId);
    if (mediaFile) {
      formData.append("MediaFile", mediaFile);
    }

    try {
      await axios.post("https://localhost:7136/api/event", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setSuccessMsg("تم إضافة الفعالية بنجاح!");
      setErrorMsg("");
      setTitle("");
      setVenue("");
      setPrice("");
      setDescription("");
      setDatetime(""); // ✅ تفريغ القيمة بعد الإرسال
      setMediaFile(null);
    } catch (error) {
      console.error("Error adding event:", error);
      setErrorMsg("حدث خطأ أثناء إضافة الفعالية.");
      setSuccessMsg("");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    navigate("/home");
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center p-8"
      style={{ backgroundImage: `url('./images/photo7.jpg')` }}
    >
      <div className="max-w-2xl mx-auto bg-white bg-opacity-80 backdrop-blur-md p-6 rounded-xl shadow-xl">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-3xl font-bold text-purple-800">إضافة فعالية جديدة</h2>
          <button
            onClick={handleLogout}
            className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition"
          >
            تسجيل الخروج
          </button>

          <button
      onClick={() => navigate('/editEvent')}
      className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition"
    >
      تعديل الفعاليات
    </button>

        </div>

        {successMsg && <p className="text-green-600 text-center mb-4">{successMsg}</p>}
        {errorMsg && <p className="text-red-600 text-center mb-4">{errorMsg}</p>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="اسم الفعالية"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full p-3 border rounded-xl"
            required
          />
          <input
            type="text"
            placeholder="المكان"
            value={venue}
            onChange={(e) => setVenue(e.target.value)}
            className="w-full p-3 border rounded-xl"
            required
          />
          <input
            type="number"
            placeholder="السعر"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            className="w-full p-3 border rounded-xl"
            required
          />

              <input
            type="number"
            placeholder="عدد التذاكر"
            value={totalTickets}
            onChange={(e) => setTotalTickets(e.target.value)}
            className="w-full p-3 border rounded-xl"
            required
          />


          <input
            type="datetime-local"
            value={datetime}
            onChange={(e) => setDatetime(e.target.value)}
            className="w-full p-3 border rounded-xl"
            required
          />

          <textarea
            placeholder="الوصف"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full p-3 border rounded-xl"
            rows={4}
            required
          />
          <input
            type="file"
            onChange={(e) => setMediaFile(e.target.files[0])}
            className="w-full p-2"
            accept="image/*,video/*"
            required
          />
          <button
            type="submit"
            className="w-full bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-xl transition"
          >
            إضافة الفعالية
          </button>
        </form>
      </div>
    </div>
  );
};

export default OrganizerPage;


